// extracted by mini-css-extract-plugin
var _1 = "RequestProfileWidgetProviders-modulecontent__Rrucu WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
export { _1 as "content" }
